/*
  Pythal policy pages: policy text is often pasted into Shopify as one paragraph of <br>-separated
  lines ("We collect:", "- Name, address"). This rebuilds those paragraphs as real headings, lists
  and paragraphs, numbers the sections and fills the "On this page" index with a scroll spy.
*/
(() => {
  const body = document.querySelector('[data-py-pol-body]');
  if (!body) return;

  const BULLET = /^[-–•·*]\s+/;
  const isHeading = (line) => /:$/.test(line) && line.length <= 60 && !BULLET.test(line);
  const labelOf = (line) => {
    const m = line.match(/^([^:.<>]{2,40}):\s+(.+)$/);
    return m && !BULLET.test(line) ? m : null;
  };
  const text = (html) => {
    const d = document.createElement('div');
    d.innerHTML = html;
    return d.textContent.trim();
  };

  const hasHeadings = () => body.querySelector(':scope > h2, :scope > h3') !== null;
  const subLevel = hasHeadings() ? 'h3' : 'h2';

  // 1. Split <br>-built paragraphs into headings, lists and paragraphs.
  body.querySelectorAll(':scope > p').forEach((p) => {
    const html = p.innerHTML.replace(/<\/?span[^>]*>/gi, '');
    const lines = html.split(/<br\s*\/?>/i).map((l) => l.trim());
    const structured = lines.some((l) => BULLET.test(text(l)) || isHeading(text(l)))
      || lines.filter((l) => labelOf(l)).length >= 2
      || /<br\s*\/?>\s*<br/i.test(html);
    if (!structured) return;

    const frag = document.createDocumentFragment();
    let list = null;
    lines.forEach((line) => {
      const plain = text(line);
      if (!plain) { list = null; return; }
      if (BULLET.test(plain)) {
        if (!list) { list = document.createElement('ul'); frag.appendChild(list); }
        const li = document.createElement('li');
        li.innerHTML = line.replace(/^\s*[-–•·*]\s+/, '');
        list.appendChild(li);
        return;
      }
      list = null;
      if (isHeading(plain)) {
        const h = document.createElement(subLevel);
        h.textContent = plain.replace(/:$/, '');
        frag.appendChild(h);
        return;
      }
      const para = document.createElement('p');
      const label = labelOf(line);
      if (label) {
        para.className = 'py-pol__term';
        const strong = document.createElement('strong');
        strong.innerHTML = `${label[1].trim()}:`;
        para.append(strong, ' ');
        para.insertAdjacentHTML('beforeend', label[2]);
      } else {
        para.innerHTML = line;
      }
      frag.appendChild(para);
    });
    p.replaceWith(frag);
  });

  // 2. A policy written entirely as "Label: text" lines reads best as one section per label.
  if (!hasHeadings()) {
    const terms = body.querySelectorAll(':scope > .py-pol__term');
    if (terms.length >= 3) {
      terms.forEach((p) => {
        const strong = p.querySelector('strong');
        const h = document.createElement('h2');
        h.textContent = strong.textContent.replace(/:$/, '');
        strong.remove();
        p.innerHTML = p.innerHTML.trim();
        p.classList.remove('py-pol__term');
        p.before(h);
      });
    }
  }

  // 3. Section headings: top-level h3s become h2s when the policy has no h2 of its own.
  if (!body.querySelector(':scope > h2')) {
    body.querySelectorAll(':scope > h3').forEach((h3) => {
      const h2 = document.createElement('h2');
      h2.innerHTML = h3.innerHTML;
      h3.replaceWith(h2);
    });
  }

  body.querySelectorAll('p').forEach((p) => { if (!p.textContent.trim() && !p.querySelector('img')) p.remove(); });

  // 4. Number the sections and build the index.
  const sections = [...body.querySelectorAll(':scope > h2')];
  const toc = document.querySelector('[data-py-pol-toc]');
  if (!toc || sections.length < 2) return;

  const list = toc.querySelector('ol');
  const links = sections.map((h, i) => {
    const slug = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    h.id = h.id || `${slug || 'section'}-${i + 1}`;
    h.setAttribute('data-py-pol-num', String(i + 1).padStart(2, '0'));
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  toc.hidden = false;
  if (window.matchMedia('(max-width: 989px)').matches) toc.open = false;
  body.classList.add('py-pol__body--numbered');

  if (!('IntersectionObserver' in window)) return;
  const setActive = (i) => links.forEach((a, j) => {
    if (i === j) a.setAttribute('aria-current', 'true');
    else a.removeAttribute('aria-current');
  });
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) setActive(sections.indexOf(e.target)); });
  }, { rootMargin: '0px 0px -70% 0px' });
  sections.forEach((h) => observer.observe(h));
  setActive(0);
})();
